import { makeDynamicConfigWidgets } from '~/helper/makeDynamicConfigWidgets';

export const cockpitOffersWidgets = makeDynamicConfigWidgets([
  {
    name: 'cockpitOffersInDetailWidget',
    cols: 12,
    props: {
      title: 'cockpit_offers_in_detail_widget_title',
      infoText: 'cockpit_offers_in_detail_widget_info_text',
    },
  },
  {
    name: 'cockpitOffersTrendWidget',
    cols: 12,
    props: {
      title: 'cockpit_offers_trend_widget_title',
      infoText: 'cockpit_offers_trend_widget_info_text',
    },
  },
]);
